/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { colors, HFlow, Icon, Text, Theme } from 'bold-ui'
import { AccordionAnimation } from 'components/accordion/AccordionAnimation'
import { AccordionButton } from 'components/accordion/AccordionButton'
import { useTheme } from 'emotion-theming'
import icon from 'images/soap/ic_puericultura.png'
import { useMemo } from 'react'
import { Accordion, AccordionItem, AccordionItemPanel } from 'react-accessible-accordion'

export interface PuericulturaAccordionProps {
  children: React.ReactNode
}

export default function PuericulturaAccordion(props: PuericulturaAccordionProps) {
  const { children } = props

  const theme = useTheme<Theme>()
  const classes = useMemo(() => styles(theme), [theme])

  return (
    <div
      css={css`
        margin: 1rem 0;
      `}
    >
      <Accordion allowZeroExpanded>
        <AccordionItem uuid='puericultura'>
          <AccordionButton
            style={classes.button}
            wrapperStyle={css`
              padding-bottom: 0;
            `}
          >
            <HFlow alignItems='center'>
              <Icon
                icon='angleDown'
                size={1.5}
                style={css`
                  margin: 0 -0.25rem;
                `}
              />

              <img src={icon} alt='Puericultura' />

              <Text fontWeight='bold' style={classes.buttonText}>
                Puericultura
              </Text>
            </HFlow>
          </AccordionButton>

          <AccordionAnimation
            wrapperStyle={css`
              margin-top: -1px;
            `}
          >
            <AccordionItemPanel css={classes.panel}>{children}</AccordionItemPanel>
          </AccordionAnimation>
        </AccordionItem>
      </Accordion>
    </div>
  )
}

const styles = (theme: Theme) => ({
  button: css`
    height: 4rem;
    display: flex;
    padding: 0 1.5rem;
    border: 1px ${colors.turquoise.c60} solid;
    background-color: ${colors.turquoise.c90};
    margin: 0;
    &:hover {
      border-color: ${colors.turquoise.c60};
      background-color: ${colors.turquoise.c90};
    },
  `,
  buttonText: css`
    color: ${colors.turquoise.c40};
  `,
  panel: css`
    border: 1px ${colors.turquoise.c60} solid;
    border-radius: ${theme.radius.input}px;
    border-top-width: 0;
  `,
})
